module.exports = __webpack_public_path__ + "img/64b6ade.v2.17.5.png";